import { useStores } from 'hooks/useStores'
import { getTranslatedTextByKey } from 'utils/language'
import OrderTypeButton from './OrderTypeButton'
import type { OrderTypeFlow } from 'mobx/Localization/types'
import { EVENTS } from 'mobx/Localization/constants'
import {
	StyledArrowBack,
	StyledCloseButton,
	StyledCloseIcon,
	StyledOrderTypesContainer,
	StyledOrderTypeSelectionContainer,
	StyledOrderTypeSelectionTitle,
} from './styles'
import { StepHeader } from 'components/localization/style'

const OrderTypeSelection = () => {
	const { localizationStore } = useStores()
	const titleText = getTranslatedTextByKey('webviewFlow.localization.selectOrderingMethod', 'Select ordering method')

	const onSelectFlow = async(flow: OrderTypeFlow) => {
		localizationStore.processingFlow?.setOrderTypeFlow(flow)

		// If flow doesn't require address and a store is pre-selected (ex: store-locator page)
		if(flow.requireAddress === false && localizationStore.processingFlow?.store) {
			const preSelectedStore = localizationStore.processingFlow?.store
			const storeAddress = await localizationStore.getAddressFromText(preSelectedStore.address)
			localizationStore.processingFlow.setAddress(storeAddress)
		}

		localizationStore.nextStep()
		localizationStore.sendLocalizationStartEvent()

		const orderType = localizationStore.processingFlow?.orderTypeFlow?.orderType
		localizationStore.sendLocalizationEvent(EVENTS.SELECT_ORDER_TYPE, {
			disposition: orderType
		})
	}

	return (
		<StyledOrderTypeSelectionContainer>
			<StepHeader>
				{localizationStore.editing && <StyledArrowBack onClick={localizationStore.edit} />}
				<StyledOrderTypeSelectionTitle variant="SubheadHighlighted">{titleText}</StyledOrderTypeSelectionTitle>
				<StyledCloseButton>
					<StyledCloseIcon data-testid="close-button" onClick={localizationStore.abort} />
				</StyledCloseButton>
			</StepHeader>
			<StyledOrderTypesContainer>
				{localizationStore.orderTypeFlows.map((orderTypeFlow) => (
					<OrderTypeButton flow={orderTypeFlow} onSelectFlow={onSelectFlow} key={orderTypeFlow.orderType} />
				))}
			</StyledOrderTypesContainer>
		</StyledOrderTypeSelectionContainer>
	)
}

export default OrderTypeSelection
